import { DescriptionService } from 'application/services/descriptions'
import { api } from 'infra/adapters/http-client-adapter'

export const handleDescriptionService = new DescriptionService(api)
